import { StrictMode } from 'react';
import { createInertiaApp } from '@inertiajs/react';
import { renderApp } from '@inertiaui/modal-react';
import { createRoot, hydrateRoot } from 'react-dom/client';

import { listenForTrackingData } from '@/lib/analytics/google-tag-manager-events';
import { INERTIA_DEFAULTS } from '@/lib/inertia-config';
import { formatInertiaTitle } from '@/lib/inertia-title';
import { resolvePage } from '@/lib/resolve-page';

createInertiaApp({
  title: formatInertiaTitle,

  resolve: (name) => resolvePage(name),

  setup({ el, App, props }) {
    if (el) {
      const app = (
        <StrictMode>
          {renderApp(
            App as unknown as Parameters<typeof renderApp>[0],
            props as Parameters<typeof renderApp>[1],
          )}
        </StrictMode>
      );
      listenForTrackingData(props.initialPage.props);

      if (el.hasChildNodes()) {
        hydrateRoot(el, app);
      } else {
        createRoot(el).render(app);
      }
    } else {
      if (import.meta.env.DEV) {
        console.error(
          'Missing root element.\n\n' +
            'If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n' +
            'Consider moving <%= vite_typescript_tag "inertia" %> to the Inertia-specific layout instead.',
        );
      }
    }
  },
  defaults: INERTIA_DEFAULTS,
});
